/*
 * Cart and product errors in Ukrainian.
 *
 * The store's locale is English, so the Cart API answers in English ("Only 1
 * item was added to your cart due to availability.") and the theme printed
 * that straight into the drawer (Alik, 15.10.2026). There is no uk.json to
 * fix it at the source — see CLAUDE.md §8 — so every message is translated
 * on its way to the screen:
 *
 *   window.cpErrorUA(msg)  maps a Cart API message to Ukrainian. A message
 *                          that is already Ukrainian passes through; an
 *                          English one nobody foresaw becomes a calm generic
 *                          line rather than staying English.
 *   window.cpToast(msg)    a short notice at the bottom of the screen, for
 *                          places that had no error slot (a size on a card).
 *
 * A MutationObserver is the safety net: whatever code writes into a known
 * error slot, English text there is replaced. Only text nodes are touched,
 * so the icon next to the message stays.
 */
(function () {
  var FALLBACK = 'Не вдалося оновити кошик. Спробуйте ще раз або напишіть нам.';
  var ENGLISH = /\b(the|your|cart|items?|only|add(ed)?|can(not|'t|’t)?|is|are|was|were|please|error|sold|available|variant|quantity|maximum|required|invalid|parameter)\b/i;
  var RULES = [
    [/only (\d+) items? (?:was|were) added to your cart/i, function (m) { return 'Додали ' + m[1] + ' шт. — більше цього розміру немає в наявності.'; }],
    [/you can only add (\d+)/i, function (m) { return 'Можна додати лише ' + m[1] + ' шт. цього розміру — більше немає в наявності.'; }],
    [/can(?:not|'t|’t) add more|all \d+ .+ (?:is|are) in your cart|maximum/i, function () { return 'У кошику вже всі доступні одиниці цього розміру.'; }],
    [/sold out|out of stock|not available|unavailable|no longer available/i, function () { return 'Цей розмір щойно розпродали. Оберіть інший.'; }],
    [/cannot find variant|variant .*not found|no valid id|required parameter/i, function () { return 'Оберіть розмір — і спробуйте ще раз.'; }],
    [/too many|throttl|try again later/i, function () { return 'Забагато запитів. Зачекайте кілька секунд і спробуйте ще раз.'; }],
  ];

  function ua(msg) {
    if (msg == null) return FALLBACK;
    var text = String(msg).trim();
    if (!text) return FALLBACK;
    if (!ENGLISH.test(text) && /[А-Яа-яІіЇїЄєҐґ]/.test(text)) return text;
    for (var i = 0; i < RULES.length; i++) {
      var m = text.match(RULES[i][0]);
      if (m) return RULES[i][1](m);
    }
    return ENGLISH.test(text) || !/[А-Яа-яІіЇїЄєҐґ]/.test(text) ? FALLBACK : text;
  }
  window.cpErrorUA = ua;

  var toastEl = null;
  var toastTimer = null;
  window.cpToast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = ua(msg);
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  };

  var SLOTS = '.cart-item__error-text, .add-to-cart-text__error, .cart-size-error, .qap-error, .complement-card__error, [data-cp-err]';

  function fix(host) {
    var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.trim();
      if (t && ENGLISH.test(t)) {
        var next = ua(t);
        if (next !== t) node.nodeValue = next;
      }
    }
  }

  function start() {
    document.querySelectorAll(SLOTS).forEach(fix);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        var el = target.nodeType === 3 ? target.parentElement : target;
        var host = el && el.closest && el.closest(SLOTS);
        if (host) fix(host);
        else if (records[i].addedNodes.length && el && el.querySelectorAll) {
          el.querySelectorAll(SLOTS).forEach(fix);
        }
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
